import {
  ApiDeleteRequest,
  ApiGetRequest,
  ApiPostRequest,
  ApiPutRequest,
} from '../../api';
import moment from 'moment-mini';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'EIR - Document Taken',
    title_form: 'EIR - Form Document Taken',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/',
      },
      {
        text: 'EIR',
        href: '/opc/eir/document-taken',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    filter: null,
    filterOn: [],
    sortBy: 'id_document_taken',
    sortDesc: true,
    fields: [
      {
        key: 'code_doc',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'taken_by',
        label: 'Take By',
        sortable: false,
      },
      {
        key: 'phone_taken',
        label: 'Phone',
        sortable: false,
      },
      {
        key: 'taken_date',
        label: 'Date',
        sortable: false,
      },
      {
        key: 'input_by',
        label: 'Input By',
        sortable: false,
      },
      {
        key: 'aksi',
      },
    ],
    form: {
      doc_no: '',
    },
    items_interchange: [],
    detail: false,
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeDocumentTaken(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
  resetForm(state) {
    state.data = Object.assign({}, state.data, {
      form: {
        doc_no: '',
      },
    });
  },
};

export const actions = {
  async getListDocumentTaken({ commit, state }) {
    commit('changeDocumentTaken', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    if (data.date_filter && data.date_filter.length > 0) {
      params.start_date = data.date_filter[0]
        ? moment(data.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.date_filter[1]
        ? moment(data.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    let result = await ApiGetRequest(`opr/document-taken`, params);
    commit('changeDocumentTaken', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailDocumentTaken({ commit }, payload = null) {
    commit('changeDocumentTaken', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/document-taken/${payload.id}`);
    let data = !result.error ? result.data.object : {};
    commit('changeDocumentTaken', {
      detail: !result.error ? result.data.object : false,
      form: {
        ...data,
        ...data.interchange,
      },
      loading: false,
    });

    return !result.error ? true : false;
  },

  async searchDocNumber({ commit }, payload) {
    commit('changeDocumentTaken', {
      loading: true,
    });

    let result = await ApiGetRequest(`opr/document-taken/search`, payload);
    commit('changeDocumentTaken', {
      items_interchange: !result.error ? result.data.object : [],
      loading: false,
    });

    return !result.error ? true : false;
  },

  async createDocumentTaken({ commit, state, dispatch }) {
    commit('changeDocumentTaken', {
      loading: true,
    });

    const { data } = state;
    let form = {
      id_interchange: data.form.id_interchange,
      doc_no: data.form.doc_no,
      phone_taken: data.form.phone_taken,
      taken_by: data.form.taken_by,
      containers: data.form.containers,
    };

    let result = await ApiPostRequest(`opr/document-taken`, form);
    commit('changeDocumentTaken', {
      loading: false,
    });

    if (!result.error) {
      commit('resetForm');
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return result.data.object;
    }

    return false;
  },

  async udpateDocumentTaken({ commit, state, dispatch }, payload = null) {
    commit('changeDocumentTaken', {
      loading: true,
    });

    const { data } = state;
    let form = {
      id_interchange: data.form.id_interchange,
      doc_no: data.form.doc_no,
      phone_taken: data.form.phone_taken,
      taken_by: data.form.taken_by,
      containers: data.form.containers,
    };

    let result = await ApiPutRequest(`opr/document-taken/${payload.id}`, form);
    commit('changeDocumentTaken', {
      loading: false,
    });

    if (!result.error) {
      commit('resetForm');
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });

      return result.data.object;
    }

    return false;
  },

  async deleteDocumentTaken({ commit, dispatch }, payload = null) {
    commit('changeDocumentTaken', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/document-taken/${payload.id}`);
    commit('changeDocumentTaken', {
      loading: false,
    });

    if (!result.error) {
      commit('resetForm');
      showNotif(dispatch, {
        message:
          (result.data.message && result.data.message) ||
          'Data berhasil dihapus',
        type: 'success',
      });

      return result.data.object;
    }

    return false;
  },
};
